import Loader from '@ui/context/session/components/Common/Loader';
import BaseOverlay from './BaseOverlay';

const SessionInitializing = () => {
  return (
    <BaseOverlay>
      <Loader size="large" text="Initializing" />
    </BaseOverlay>
  );
};

export default SessionInitializing;
